import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import e, { useState as t } from "react";
import { oneOf as r, arrayOf as n, string as i, number as a, oneOfType as l, shape as o, node as s } from "prop-types";
import { Box as c, Flex as m, Badge as p, Text as x, Grid as g, Link as f, Button as d, Container as u, Heading as h, Close as v, MenuButton as b, AspectRatio as y } from "theme-ui";

function E() {
  return (E = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function C(e, t) {
  if (null == e) return {};
  var r,
      n,
      i = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) {
    t.indexOf(r = a[n]) >= 0 || (i[r] = e[r]);
  }

  return i;
}

var w = function w(e) {
  var t = {
    start: "flex-start",
    center: "center",
    end: "flex-end"
  };
  return Array.isArray(e) ? e.map(function (e) {
    return t[e];
  }) : t[e];
},
    k = function k(t) {
  var r = t.values,
      _t$gap = t.gap,
      n = _t$gap === void 0 ? 2 : _t$gap,
      _t$align = t.align,
      i = _t$align === void 0 ? "start" : _t$align,
      _t$variant = t.variant,
      a = _t$variant === void 0 ? "badges.primary" : _t$variant,
      l = C(t, ["values", "gap", "align", "variant"]);
  return e.createElement(c, l, e.createElement(m, {
    sx: {
      justifyContent: w(i),
      flexWrap: "wrap",
      mr: -n,
      mb: -n
    }
  }, r.map(function (t) {
    return e.createElement(p, {
      key: t,
      sx: {
        variant: a,
        mr: n,
        mb: n
      }
    }, t);
  })));
},
    R = r(["start", "center", "end"]);

k.propTypes = {
  values: n(i.isRequired).isRequired,
  gap: a,
  align: l([R, n(R)]),
  variant: i
};

var q = function q(t) {
  var r = t.profile,
      _t$align2 = t.align,
      n = _t$align2 === void 0 ? "center" : _t$align2,
      _t$variant2 = t.variant,
      i = _t$variant2 === void 0 ? "badges.primary" : _t$variant2,
      a = C(t, ["profile", "align", "variant"]);
  return e.createElement(m, E({}, a, {
    sx: {
      flexDirection: "column",
      alignItems: w(n),
      fontFamily: "body"
    }
  }), r.avatar, r.honorific && e.createElement(x, {
    sx: {
      fontSize: 1,
      lineHeight: "body",
      textAlign: n
    }
  }, r.honorific), r.name, r.jobtitle && e.createElement(x, {
    sx: {
      fontSize: 2,
      lineHeight: "body",
      textAlign: n
    }
  }, r.jobtitle), r.organization && e.createElement(x, {
    sx: {
      fontSize: 2,
      fontWeight: "bold",
      lineHeight: "body",
      textAlign: n
    }
  }, r.organization), r.socialIcons, r.badges && e.createElement(k, {
    values: r.badges,
    align: n,
    variant: i,
    mt: 2
  }));
},
    z = r(["start", "center", "end"]);

q.propTypes = {
  profile: o({
    avatar: s.isRequired,
    honorific: i,
    name: s,
    jobtitle: i,
    organization: i,
    socialIcons: s,
    badges: n(i)
  }).isRequired,
  align: l([z, n(z)]),
  variant: i
};

var T = function T(t) {
  var r = t.values,
      _t$align3 = t.align,
      n = _t$align3 === void 0 ? "start" : _t$align3,
      i = C(t, ["values", "align"]);
  return e.createElement(g, E({}, i, {
    gap: 2,
    sx: {
      gridTemplateColumns: "repeat(auto-fit, 96px)",
      justifyItems: n,
      justifyContent: n,
      alignSelf: "stretch"
    }
  }), r.map(function (_ref) {
    var t = _ref.id,
        r = _ref.avatar,
        i = _ref.name,
        a = _ref.href;
    return e.createElement(f, {
      key: t,
      href: a,
      sx: {
        color: "inherit",
        textDecoration: "none"
      }
    }, e.createElement(q, {
      profile: {
        avatar: r,
        name: i
      },
      fontSize: 1,
      align: n
    }));
  }));
},
    D = r(["start", "center", "end"]);

T.propTypes = {
  values: n(o({
    id: i.isRequired,
    avatar: s.isRequired,
    name: s,
    href: i.isRequired
  })).isRequired,
  align: l([D, n(D)])
};

var S = function S(t) {
  var _t$color = t.color,
      r = _t$color === void 0 ? "primary" : _t$color,
      n = t.title,
      i = t.subtitle,
      a = t.children,
      l = C(t, ["color", "title", "subtitle", "children"]);
  return e.createElement(c, E({}, l, {
    sx: {
      border: "1px solid",
      borderColor: r
    }
  }), e.createElement(c, {
    sx: {
      color: "background",
      bg: r,
      p: [2, 3],
      mb: [2, 3]
    }
  }, n, i && i), e.createElement(c, {
    sx: {
      px: [2, 3],
      mb: [2, 3]
    }
  }, a));
};

S.propTypes = {
  color: i,
  title: s.isRequired,
  subtitle: s,
  children: s.isRequired
};

var j = function j(t) {
  var _t$size = t.size,
      r = _t$size === void 0 ? 32 : _t$size,
      n = C(t, ["size"]);
  return e.createElement(c, E({}, n, {
    sx: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: r,
      height: r,
      color: "inherit",
      bg: "transparent"
    }
  }));
};

j.propTypes = {
  size: l([a, n(a)])
};

var L = function L(t) {
  var r = t.size,
      n = t.title,
      i = C(t, ["size", "title"]);
  return e.createElement(j, E({}, i, {
    size: r,
    "aria-label": "E-mail icon"
  }), e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    fill: "currentColor",
    viewBox: "0 0 14 10"
  }, n && e.createElement("title", null, n), e.createElement("path", {
    d: "M0 1V9C0 9.55 0.45 10 1 10H13C13.55 10 14 9.55 14 9V1C14 0.45 13.55 0 13 0H1C0.45 0 0 0.45 0 1ZM13 1L7 6L1 1H13ZM1 2.5L5 5.5L1 8.5V2.5ZM2 9L5.5 6L7 7.5L8.5 6L12 9H2ZM13 8.5L9 5.5L13 2.5V8.5Z"
  })));
};

L.propTypes = {
  size: l([a, n(a)]),
  title: i
};

var I = function I(t) {
  var r = t.event,
      n = C(t, ["event"]);
  return e.createElement(m, E({}, n, {
    sx: {
      flexDirection: "column",
      alignItems: "flex-start",
      fontFamily: "body"
    }
  }), r.tag && e.createElement(c, {
    sx: {
      mb: 2
    }
  }, e.createElement(p, {
    sx: {
      variant: "event-preview.badge"
    }
  }, r.tag)), r.title, r.speakers, e.createElement(x, {
    as: "time",
    sx: {
      display: "block",
      textAlign: "start",
      mb: r.description || r.href || r.registrationLink ? 3 : 0
    }
  }, r.date), r.description, (r.href || r.registrationLink) && e.createElement(m, {
    sx: {
      flexGrow: 1,
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-end"
    }
  }, r.href && e.createElement(d, {
    as: f,
    sx: {
      variant: "event-preview.buttons.event",
      mr: r.registrationLink ? [2, 3] : 0
    },
    href: r.href
  }, "Details"), r.registrationLink && e.createElement(d, {
    as: f,
    href: r.registrationLink,
    sx: {
      variant: "event-preview.buttons.registration"
    }
  }, "Register")));
};

I.propTypes = {
  event: o({
    tag: i,
    title: s.isRequired,
    date: i.isRequired,
    speakers: s,
    description: s,
    href: i,
    registrationLink: i
  }).isRequired
};

var H = function H(_ref2) {
  var t = _ref2.logo,
      r = _ref2.title,
      n = _ref2.socialIcons,
      i = _ref2.links;
  return e.createElement(c, {
    sx: {
      color: "background",
      bg: "secondary",
      variant: "footer"
    }
  }, e.createElement(u, {
    sx: {
      maxWidth: "96em",
      px: [2, 3, 4],
      py: 4,
      variant: "footer.container"
    }
  }, e.createElement(m, {
    as: "footer",
    sx: {
      flexDirection: "column",
      alignItems: "center"
    }
  }, t && e.createElement(f, {
    href: "/",
    sx: {
      mb: [3, 4],
      variant: "footer.logo",
      color: "inherit",
      height: "100%",
      textDecoration: "none"
    }
  }, t), r && e.createElement(f, {
    href: "/",
    sx: {
      mb: [2, 3],
      variant: "footer.title",
      color: "inherit",
      textDecoration: "none"
    }
  }, e.createElement(h, {
    sx: {
      whiteSpace: "nowrap",
      fontSize: [3, 4, 5]
    }
  }, r)), n, e.createElement(m, {
    sx: {
      flexWrap: "wrap",
      justifyContent: "center"
    }
  }, i.map(function (t) {
    return e.createElement(f, {
      href: t.href,
      key: t.href,
      sx: {
        color: "inherit",
        textDecoration: "none",
        px: [2, 3],
        py: [1, 2]
      }
    }, e.createElement(x, {
      sx: {
        fontFamily: "body",
        textAlign: "center"
      }
    }, t.text));
  })))));
};

H.propTypes = {
  logo: s,
  title: i,
  socialIcons: s,
  links: n(o({
    text: i.isRequired,
    href: i,
    label: i
  })).isRequired
};

var A = function A(t) {
  var r = t.size,
      n = t.title,
      i = C(t, ["size", "title"]);
  return e.createElement(j, E({}, i, {
    size: r,
    "aria-label": "GitHub icon"
  }), e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, n && e.createElement("title", null, n), e.createElement("path", {
    d: "M12 0.296997C5.37 0.296997 0 5.67 0 12.297C0 17.6 3.438 22.097 8.205 23.682C8.805 23.795 9.025 23.424 9.025 23.105C9.025 22.82 9.015 22.065 9.01 21.065C5.672 21.789 4.968 19.455 4.968 19.455C4.422 18.07 3.633 17.7 3.633 17.7C2.546 16.956 3.717 16.971 3.717 16.971C4.922 17.055 5.555 18.207 5.555 18.207C6.625 20.042 8.364 19.512 9.05 19.205C9.158 18.429 9.467 17.9 9.81 17.6C7.145 17.3 4.344 16.268 4.344 11.67C4.344 10.36 4.809 9.29 5.579 8.45C5.444 8.147 5.039 6.927 5.684 5.274C5.684 5.274 6.689 4.952 8.984 6.504C9.944 6.237 10.964 6.105 11.984 6.099C13.004 6.105 14.024 6.237 14.984 6.504C17.264 4.952 18.269 5.274 18.269 5.274C18.914 6.927 18.509 8.147 18.389 8.45C19.154 9.29 19.619 10.36 19.619 11.67C19.619 16.28 16.814 17.295 14.144 17.59C14.564 17.95 14.954 18.686 14.954 19.81C14.954 21.416 14.939 22.706 14.939 23.096C14.939 23.411 15.149 23.786 15.764 23.666C20.565 22.092 24 17.592 24 12.297C24 5.67 18.627 0.296997 12 0.296997"
  })));
};

A.propTypes = {
  size: l([a, n(a)]),
  title: i
};

var W = e.createContext({}),
    O = [48, 64, 80],
    M = function M(r) {
  var n = r.logo,
      i = r.title,
      a = r.links,
      l = r.button,
      o = C(r, ["logo", "title", "links", "button"]);

  var _t = t(!1),
      _t2 = _slicedToArray(_t, 2),
      s = _t2[0],
      p = _t2[1];

  return e.createElement(W.Provider, {
    value: {
      menuOpen: s,
      setMenuOpen: p
    }
  }, e.createElement(c, E({}, o, {
    sx: {
      color: "background",
      bg: "primary",
      variant: "header"
    }
  }), e.createElement(u, {
    sx: {
      maxWidth: "96em",
      px: [2, 3, 4],
      py: [2, 3],
      variant: "header.container"
    }
  }, e.createElement(m, {
    as: "header",
    sx: {
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      height: O
    }
  }, n && e.createElement(f, {
    href: "/",
    "aria-label": "Back to homepage",
    sx: {
      color: "inherit",
      height: "100%",
      flexShrink: 0,
      textDecoration: "none",
      mr: [2, 3]
    }
  }, n), i && e.createElement(f, {
    href: "/",
    "aria-label": "Back to homepage",
    sx: {
      color: "inherit",
      flex: "none",
      textDecoration: "none",
      mr: [0, 3, 4]
    }
  }, e.createElement(h, {
    as: "div",
    sx: {
      whiteSpace: "nowrap",
      fontSize: [4, 5, 6]
    }
  }, i)), e.createElement(c, {
    as: "nav",
    sx: {
      bg: "primary",
      variant: "header.nav",
      display: [s ? "flex" : "none", "flex"],
      flexDirection: ["column", "row"],
      justifyContent: ["flex-start", "flex-end"],
      alignItems: "center",
      flex: 1,
      position: ["fixed", "static"],
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      pb: [4, 0]
    }
  }, e.createElement(c, {
    "aria-label": "Close navigation",
    sx: {
      display: ["block", "none"],
      height: O,
      width: "100%",
      textAlign: "right",
      p: 2,
      my: 2
    },
    onClick: function onClick() {
      p(!1);
    }
  }, e.createElement(v, {
    css: {
      WebkitTapHighlightColor: "transparent"
    }
  })), e.createElement(m, {
    sx: {
      flexDirection: ["column", "row"],
      alignItems: "center",
      overflow: "auto"
    }
  }, e.createElement(f, {
    key: "/",
    href: "/",
    "aria-label": "Back to homepage",
    sx: {
      color: "inherit",
      display: ["flex", "none"],
      textDecoration: "none",
      mb: [4, 0],
      ml: [0, 3, 4]
    }
  }, e.createElement(h, {
    as: "div",
    sx: {
      fontSize: [4, 3, 4]
    }
  }, "Home")), a.map(function (_ref3) {
    var t = _ref3.href,
        r = _ref3.text;
    return e.createElement(f, {
      key: t,
      href: t,
      sx: {
        color: "inherit",
        flexShrink: 0,
        fontSize: [4, 3, 4],
        textDecoration: "none",
        mb: [4, 0],
        mr: [0, 3, 4],
        "&:last-of-type": {
          mr: 0,
          mb: 0
        }
      }
    }, e.createElement(h, {
      as: "div",
      sx: {
        fontSize: [4, 3, 4]
      }
    }, r));
  })), l && e.createElement(d, {
    as: f,
    href: l.href,
    sx: {
      color: "primary",
      bg: "background",
      variant: "header.cta",
      flex: "none",
      mt: [4, 0],
      ml: [0, 3, 4]
    }
  }, e.createElement(h, {
    as: "div",
    sx: {
      fontSize: [4, 3, 4]
    }
  }, l.text))), e.createElement(c, {
    "aria-label": "Open navigation",
    sx: {
      display: ["block", "none"],
      flex: 1,
      height: "100%",
      textAlign: "right",
      py: 2,
      zIndex: 1
    },
    onClick: function onClick() {
      p(!0);
    }
  }, e.createElement(b, {
    css: {
      WebkitTapHighlightColor: "transparent"
    },
    "aria-label": "Open navigation"
  }))))));
},
    B = o({
  text: i.isRequired,
  href: i
});

M.propTypes = {
  logo: s,
  title: i,
  links: n(B).isRequired,
  button: B
};

var F = function F(t) {
  var r = t.values,
      _t$align4 = t.align,
      n = _t$align4 === void 0 ? "start" : _t$align4,
      _t$variant3 = t.variant,
      i = _t$variant3 === void 0 ? "names.default" : _t$variant3,
      a = C(t, ["values", "align", "variant"]);
  return e.createElement(x, E({
    as: "div"
  }, a, {
    sx: {
      fontFamily: "body",
      lineHeight: "body",
      variant: i,
      textAlign: n
    }
  }), r.join(", "));
},
    Z = r(["start", "center", "end"]);

F.propTypes = {
  values: n(i).isRequired,
  align: l([Z, n(Z)]),
  variant: i
};

var V = function V(_ref4) {
  var t = _ref4.children,
      r = _ref4.href,
      n = _ref4.className;
  return e.createElement("a", {
    className: n,
    href: r,
    target: "_blank",
    rel: "noreferrer noopener"
  }, t);
};

V.propTypes = {
  children: s.isRequired,
  href: i,
  className: i
};

var G = function G(t) {
  var r = t.post,
      n = C(t, ["post"]);
  var i = r.description || r.href ? 3 : 0;
  return e.createElement(m, E({}, n, {
    sx: {
      flexDirection: "column",
      fontFamily: "body"
    }
  }), r.tag && e.createElement(c, {
    sx: {
      mb: 2
    }
  }, e.createElement(p, {
    sx: {
      variant: "post-preview.badge"
    }
  }, r.tag)), r.title, r.authors && r.authors, e.createElement(x, {
    as: "time",
    sx: {
      display: "block",
      mb: i
    }
  }, r.date), r.description && r.description, r.href && e.createElement(m, {
    sx: {
      flexGrow: 1,
      flexDirection: "column",
      justifyContent: "flex-end"
    }
  }, e.createElement(d, {
    as: f,
    sx: {
      variant: "post-preview.button",
      alignSelf: ["stretch", "flex-start"],
      whiteSpace: "nowrap"
    },
    href: r.href
  }, "Read on")));
};

G.propTypes = {
  post: o({
    tag: i,
    title: s.isRequired,
    date: i.isRequired,
    authors: s,
    description: s,
    href: i
  }).isRequired
};

var N = function N(t) {
  var r = t.values,
      _t$align5 = t.align,
      n = _t$align5 === void 0 ? "start" : _t$align5,
      i = C(t, ["values", "align"]);
  return e.createElement(c, i, e.createElement(m, {
    sx: {
      flexWrap: "wrap",
      justifyContent: w(n),
      alignItems: "center",
      mx: -2
    }
  }, r.map(function (_ref5) {
    var t = _ref5.id,
        r = _ref5.icon;
    return e.createElement(c, {
      key: t,
      sx: {
        mx: 2
      }
    }, r);
  })));
},
    P = r(["start", "center", "end"]);

N.propTypes = {
  values: n(o({
    id: i.isRequired,
    icon: s.isRequired
  })).isRequired,
  align: l([P, n(P)])
};

var $ = function $(t) {
  var r = t.id,
      n = t.title,
      _t$ratio = t.ratio,
      i = _t$ratio === void 0 ? 16 / 9 : _t$ratio,
      a = C(t, ["id", "title", "ratio"]);
  return e.createElement(y, E({}, a, {
    ratio: i
  }), e.createElement("iframe", {
    width: "100%",
    height: "100%",
    src: "https://www.youtube-nocookie.com/embed/".concat(r, "?rel=0"),
    title: n,
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: !0
  }));
};

$.propTypes = {
  id: i.isRequired,
  title: i.isRequired,
  ratio: a
};

var _ = function _(t) {
  var r = t.values,
      _t$gap2 = t.gap,
      n = _t$gap2 === void 0 ? 2 : _t$gap2,
      _t$align6 = t.align,
      i = _t$align6 === void 0 ? "start" : _t$align6,
      _t$variant4 = t.variant,
      a = _t$variant4 === void 0 ? "tags.primary" : _t$variant4,
      l = C(t, ["values", "gap", "align", "variant"]);
  return 0 === r.length ? null : e.createElement(c, l, e.createElement(m, {
    sx: {
      justifyContent: w(i),
      flexWrap: "wrap",
      mr: -n,
      mb: -n
    }
  }, r.map(function (_ref6) {
    var t = _ref6.tag,
        r = _ref6.path;
    return e.createElement(f, {
      href: r,
      key: t,
      sx: {
        textDecoration: "none",
        mr: n,
        mb: n
      }
    }, e.createElement(p, {
      sx: {
        variant: a,
        display: "block"
      },
      variant: a
    }, t));
  })));
},
    J = r(["start", "center", "end"]);

_.propTypes = {
  values: n(o({
    tag: i.isRequired,
    path: i.isRequired
  })).isRequired,
  gap: a,
  align: l([J, n(J)]),
  variant: i
};

var K = function K(t) {
  var r = t.size,
      n = t.title,
      i = C(t, ["size", "title"]);
  return e.createElement(j, E({}, i, {
    size: r,
    "aria-label": "Twitter icon"
  }), e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    fill: "currentColor",
    viewBox: "0 0 24 20"
  }, n && e.createElement("title", null, n), e.createElement("path", {
    d: "M23.954 2.56897C23.069 2.95797 22.124 3.22297 21.129 3.34397C22.143 2.73297 22.923 1.76997 23.292 0.620972C22.341 1.17597 21.287 1.57997 20.165 1.80497C19.269 0.845972 17.992 0.245972 16.574 0.245972C13.857 0.245972 11.654 2.44897 11.654 5.16297C11.654 5.55297 11.699 5.92797 11.781 6.28697C7.691 6.09397 4.066 4.12997 1.64 1.16097C1.213 1.88297 0.974 2.72197 0.974 3.63597C0.974 5.34597 1.844 6.84897 3.162 7.73197C2.355 7.70597 1.596 7.48397 0.934 7.11597V7.17697C0.934 9.56197 2.627 11.551 4.88 12.004C4.467 12.115 4.031 12.175 3.584 12.175C3.27 12.175 2.969 12.145 2.668 12.089C3.299 14.042 5.113 15.466 7.272 15.506C5.592 16.825 3.463 17.611 1.17 17.611C0.78 17.611 0.391 17.588 0 17.544C2.189 18.938 4.768 19.753 7.557 19.753C16.611 19.753 21.556 12.257 21.556 5.76697C21.556 5.55797 21.556 5.34697 21.541 5.13697C22.502 4.44797 23.341 3.57697 24.001 2.58897L23.954 2.56897Z"
  })));
};

K.propTypes = {
  size: l([a, n(a)]),
  title: i
};
export { T as Avatars, k as Badges, S as Card, L as EmailIcon, I as EventPreview, H as Footer, A as GitHubIcon, M as Header, j as Icon, F as Names, V as NewTabLink, G as PostPreview, q as ProfilePreview, N as SocialIcons, _ as Tags, K as TwitterIcon, $ as Video };